import httpService from "../../service";

export default {
    async fetchSsoSystems() {
        const resp = await httpService.getWithoutCampaign("/sso/admin/system");
        this.throwErrorOnErrorCode(resp);
        return this.deserializeSsoSystems(resp);
    },

    async createSsoSystem(ssoSystem) {
        const resp = await httpService.postWithoutCampaign("/sso/admin/system", this.serializeSsoSystem(ssoSystem));
        this.throwErrorOnErrorCode(resp);
        return this.deserializeSingleSsoSystem(resp);
    },

    async deleteSsoSystem(ssoSystem) {
        const resp = await httpService.deleteWithoutCampaign("/sso/admin/system/" + ssoSystem.id);
        this.throwErrorOnErrorCode(resp);
        return resp;
    },

    async updateSsoSystem(ssoSystem) {
        const resp = await httpService.putWithoutCampaign("/sso/admin/system/" + ssoSystem.id, this.serializeSsoSystem(ssoSystem));
        this.throwErrorOnErrorCode(resp);
        return this.deserializeSingleSsoSystem(resp);
    },

    // "httpservice doesn't throw a catchable error. Instead it returns a response with a certain error code.
    // By throwing a fresh error ourselves components can catch and handle the error.
    throwErrorOnErrorCode(resp) {
        if (resp.code !== undefined && resp.code === 400) {
            throw new Error(resp.message);
        }
    },

    // transform 'our' data into data expected by the API and create a JSON string from it
    serializeSsoSystem(ssoSystem) {
        // clone the object to avoid undesired side effects caused by 'passed by value'
        let serializedSsoSystem = this.cloneObject(ssoSystem);
        let { configuration } = ssoSystem;
        serializedSsoSystem.configuration = {
            idp: {
                entityId: configuration.idpEntityId,
                singleSignOnService: {
                    url: configuration.idpSingleSignOnServiceUrl
                },
                x509cert: configuration.idpX509cert
            },
            sp: {
                entityId: configuration.spEntityId,
                assertionConsumerService: {
                    url: configuration.spAssertionConsumerServiceUrl
                },
                singleLogoutService: {
                    url: configuration.idpSingleSignOnServiceUrl
                }
            }
        };
        return JSON.stringify(serializedSsoSystem);
    },

    // transform the data provided by the API into data expected by the frontend application
    deserializeSsoSystems(ssoSystems) {
        return ssoSystems.map(ssoSystem => {
            return this.deserializeSingleSsoSystem(ssoSystem);
        });
    },

    deserializeSingleSsoSystem(ssoSystem) {
        // clone the object to avoid undesired side effects caused by 'passed by value'
        let deserializedSsoSystem = this.cloneObject(ssoSystem);
        let { configuration } = ssoSystem;
        deserializedSsoSystem.configuration = {};
        deserializedSsoSystem.configuration.idpEntityId = configuration.idp.entityId;
        deserializedSsoSystem.configuration.idpSingleSignOnServiceUrl = configuration.idp.singleSignOnService.url;
        deserializedSsoSystem.configuration.idpX509cert = configuration.idp.x509cert;
        deserializedSsoSystem.configuration.spEntityId = configuration.sp.entityId;
        deserializedSsoSystem.configuration.spAssertionConsumerServiceUrl = configuration.sp.assertionConsumerService.url;
        deserializedSsoSystem.configuration.spSingleLogoutServiceUrl = configuration.sp.singleLogoutService.url;
        return deserializedSsoSystem;
    },

    // creates a clone of the passed-in object
    cloneObject(obj) {
        return { ...obj };
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/sso-system/SsoSystemHttpService.js